import store from '@/store'
export const CommonFormat = {
    //受理登记图片的
    GetSourceTypeAcceptanceRegistration() {
        return 1;
    },
    //1性别信息,2政策措施类别3政策措施类型,4终止原因,5资金比例注销原因,6出台单位级别,7是否可资金量化,8普通用户注销原因,9审批意见,10证件类型,11养老保险类别,12与父亲关系,13审核不通过原因,14身体状况,15残疾类型,16残疾等级,17被收养人身份，18扶助对象注销原因 20：民族信息 21：银行信息
    dealWithLocationData(code) {
        let returnArray = [];
        let currentArray = [];
        switch (code) {
            case 1:
                //1性别信息
                currentArray = this.sexlist
                break;
            case 10:
                //10证件类型
                currentArray = this.certificateTypeList
                break;
            case 11:
                //养老保险类型
                currentArray = this.providelist
                break;
            case 12:
                //与父亲母亲关系
                currentArray = this.fatherlist
                break;
            case 14:
                //身体状况
                currentArray = this.physicallist
                break;
            case 15:
                //残疾类型
                currentArray = this.disabilitytypeslist
                break;
            case 16:
                //残疾等级
                currentArray = this.disabilitygradelist
                break;
            case 17:
                //17被收养人身份
                currentArray = this.adoptedStatusList
                break;
            case 20:
                //民族
                currentArray = this.ethnicGroupList
                break;
            case 21:
                //银行
                currentArray = this.bankList
                break;
            default:
                break;
        }

        currentArray.forEach((e) => {
            let obj = {
                value: e.systemCodeID,
                label: e.systemCodeName,
            }
            returnArray.push(obj)
        })

        return returnArray;
    },
    sexlist: [
        { systemCodeID: 1, systemCodeName: '男' },
        { systemCodeID: 2, systemCodeName: '女' },
    ],
    //证件类型
    certificateTypeList: [
        { "systemCodeID": 1, "systemCodeName": "居民身份证", "systemCode": 1 },
        { "systemCodeID": 3, "systemCodeName": "护照", "systemCode": 2 },
        { "systemCodeID": 2, "systemCodeName": "军官证", "systemCode": 3 },
        { "systemCodeID": 4, "systemCodeName": "港澳身份证", "systemCode": 4 },
        { "systemCodeID": 5, "systemCodeName": "台湾通行证", "systemCode": 5 },
        { "systemCodeID": 6, "systemCodeName": "解放军身份证", "systemCode": 6 },
        { "systemCodeID": 7, "systemCodeName": "武警身份证", "systemCode": 7 },
        { "systemCodeID": 8, "systemCodeName": "其他证件", "systemCode": 8 }
    ],
    //被收养者身份
    adoptedStatusList: [
        { "systemCodeID": 1, "systemCodeName": "孤儿", "systemCode": 1 },
        { "systemCodeID": 2, "systemCodeName": "残疾儿童", "systemCode": 2 },
        { "systemCodeID": 3, "systemCodeName": "福利院抚养儿童", "systemCode": 3 },
        { "systemCodeID": 4, "systemCodeName": "其他", "systemCode": 9 }
    ],
    //养老保险类型
    providelist: [
        { "systemCodeID": 1, "systemCodeName": "城镇职工", "systemCode": 1 },
        { "systemCodeID": 2, "systemCodeName": "城乡居民", "systemCode": 2 }
    ],
    //与父亲母亲关系
    fatherlist: [
        { "systemCodeID": 1, "systemCodeName": "本人亲生", "systemCode": 1 },
        { "systemCodeID": 2, "systemCodeName": "本人抱养", "systemCode": 2 },
        { "systemCodeID": 3, "systemCodeName": "配偶亲生非本人亲生", "systemCode": 3 },
        { "systemCodeID": 4, "systemCodeName": "配偶抱养非本人抱养", "systemCode": 4 }
    ],
    //身体状况
    physicallist: [
        { "systemCodeID": 1, "systemCodeName": "存活", "systemCode": 1 },
        { "systemCodeID": 2, "systemCodeName": "残疾", "systemCode": 2 },
        { "systemCodeID": 3, "systemCodeName": "患病", "systemCode": 3 },
        { "systemCodeID": 4, "systemCodeName": "死亡", "systemCode": 4 }
    ],
    //残疾类型
    disabilitytypeslist: [
        { "systemCodeID": 1, "systemCodeName": "精神残疾", "systemCode": 1 },
        { "systemCodeID": 2, "systemCodeName": "肢体残疾", "systemCode": 2 },
        { "systemCodeID": 3, "systemCodeName": "智力残疾", "systemCode": 3 },
        { "systemCodeID": 4, "systemCodeName": "言语残疾", "systemCode": 4 },
        { "systemCodeID": 5, "systemCodeName": "听力残疾", "systemCode": 5 },
        { "systemCodeID": 6, "systemCodeName": "视力残疾", "systemCode": 6 }
    ],
    //残疾等级
    disabilitygradelist: [
        { "systemCodeID": 1, "systemCodeName": "一级", "systemCode": 1 }, { "systemCodeID": 2, "systemCodeName": "二级", "systemCode": 2 }, { "systemCodeID": 3, "systemCodeName": "三级", "systemCode": 3 }, { "systemCodeID": 4, "systemCodeName": "四级", "systemCode": 4 }
    ],
    //民族
    ethnicGroupList: [
        { "systemCodeID": 1, "systemCodeName": "汉族", "systemCode": 1 },
        { "systemCodeID": 2, "systemCodeName": "蒙古族", "systemCode": 2 },
        { "systemCodeID": 3, "systemCodeName": "回族", "systemCode": 3 },
        { "systemCodeID": 4, "systemCodeName": "藏族", "systemCode": 4 },
        { "systemCodeID": 5, "systemCodeName": "维吾尔族", "systemCode": 5 },
        { "systemCodeID": 6, "systemCodeName": "苗族", "systemCode": 6 },
        { "systemCodeID": 7, "systemCodeName": "彝族", "systemCode": 7 },
        { "systemCodeID": 8, "systemCodeName": "壮族", "systemCode": 8 },
        { "systemCodeID": 9, "systemCodeName": "布依族", "systemCode": 9 },
        { "systemCodeID": 10, "systemCodeName": "朝鲜族", "systemCode": 10 },
        { "systemCodeID": 11, "systemCodeName": "满族", "systemCode": 11 },
        { "systemCodeID": 12, "systemCodeName": "侗族", "systemCode": 12 },
        { "systemCodeID": 13, "systemCodeName": "瑶族", "systemCode": 13 },
        { "systemCodeID": 14, "systemCodeName": "白族", "systemCode": 14 },
        { "systemCodeID": 15, "systemCodeName": "土家族", "systemCode": 15 },
        { "systemCodeID": 16, "systemCodeName": "哈尼族", "systemCode": 16 },
        { "systemCodeID": 17, "systemCodeName": "哈萨克族", "systemCode": 17 },
        { "systemCodeID": 18, "systemCodeName": "傣族", "systemCode": 18 },
        { "systemCodeID": 19, "systemCodeName": "黎族", "systemCode": 19 },
        { "systemCodeID": 20, "systemCodeName": "僳僳族", "systemCode": 20 },
        { "systemCodeID": 21, "systemCodeName": "佤族", "systemCode": 21 },
        { "systemCodeID": 22, "systemCodeName": "畲族", "systemCode": 22 },
        { "systemCodeID": 23, "systemCodeName": "高山族", "systemCode": 23 },
        { "systemCodeID": 24, "systemCodeName": "拉祜族", "systemCode": 24 },
        { "systemCodeID": 25, "systemCodeName": "水族", "systemCode": 25 },
        { "systemCodeID": 26, "systemCodeName": "东乡族", "systemCode": 26 },
        { "systemCodeID": 27, "systemCodeName": "纳西族", "systemCode": 27 },
        { "systemCodeID": 28, "systemCodeName": "景颇族", "systemCode": 28 },
        { "systemCodeID": 29, "systemCodeName": "柯尔克孜族", "systemCode": 29 },
        { "systemCodeID": 30, "systemCodeName": "土族", "systemCode": 30 },
        { "systemCodeID": 31, "systemCodeName": "达斡尔族", "systemCode": 31 },
        { "systemCodeID": 32, "systemCodeName": "仫佬族", "systemCode": 32 },
        { "systemCodeID": 33, "systemCodeName": "羌族", "systemCode": 33 },
        { "systemCodeID": 34, "systemCodeName": "布朗族", "systemCode": 34 },
        { "systemCodeID": 35, "systemCodeName": "撤拉族", "systemCode": 35 },
        { "systemCodeID": 36, "systemCodeName": "毛难族", "systemCode": 36 },
        { "systemCodeID": 37, "systemCodeName": "仡佬族", "systemCode": 37 },
        { "systemCodeID": 38, "systemCodeName": "锡伯族", "systemCode": 38 },
        { "systemCodeID": 39, "systemCodeName": "阿昌族", "systemCode": 39 },
        { "systemCodeID": 40, "systemCodeName": "普米族", "systemCode": 40 },
        { "systemCodeID": 41, "systemCodeName": "塔吉克族", "systemCode": 41 },
        { "systemCodeID": 42, "systemCodeName": "怒族", "systemCode": 42 },
        { "systemCodeID": 43, "systemCodeName": "乌孜别克族", "systemCode": 43 },
        { "systemCodeID": 44, "systemCodeName": "俄罗斯族", "systemCode": 44 },
        { "systemCodeID": 45, "systemCodeName": "鄂温克族", "systemCode": 45 },
        { "systemCodeID": 46, "systemCodeName": "崩龙族", "systemCode": 46 },
        { "systemCodeID": 47, "systemCodeName": "保安族", "systemCode": 47 },
        { "systemCodeID": 48, "systemCodeName": "裕固族", "systemCode": 48 },
        { "systemCodeID": 49, "systemCodeName": "京族", "systemCode": 49 },
        { "systemCodeID": 50, "systemCodeName": "塔塔尔族", "systemCode": 50 },
        { "systemCodeID": 51, "systemCodeName": "独龙族", "systemCode": 51 },
        { "systemCodeID": 52, "systemCodeName": "鄂伦春族", "systemCode": 52 },
        { "systemCodeID": 53, "systemCodeName": "珞巴族", "systemCode": 53 },
        { "systemCodeID": 54, "systemCodeName": "赫哲族", "systemCode": 54 },
        { "systemCodeID": 55, "systemCodeName": "门巴族", "systemCode": 55 },
        { "systemCodeID": 56, "systemCodeName": "基诺族", "systemCode": 56 }
    ],
    //银行
    bankList: [
        { "systemCodeID": 1, "systemCodeName": "农业银行", "systemCode": 1 },
        { "systemCodeID": 2, "systemCodeName": "邮政银行", "systemCode": 2 },
        { "systemCodeID": 3, "systemCodeName": "农商银行(河南农信)", "systemCode": 3 },
        { "systemCodeID": 4, "systemCodeName": "建设银行", "systemCode": 4 },
        { "systemCodeID": 5, "systemCodeName": "中国银行", "systemCode": 5 },
        { "systemCodeID": 6, "systemCodeName": "工商银行", "systemCode": 6 },
        { "systemCodeID": 7, "systemCodeName": "交通银行", "systemCode": 7 },
        { "systemCodeID": 8, "systemCodeName": "招商银行", "systemCode": 8 },
        { "systemCodeID": 9, "systemCodeName": "中原银行", "systemCode": 9 },
        { "systemCodeID": 10, "systemCodeName": "洛阳银行", "systemCode": 10 },
        { "systemCodeID": 11, "systemCodeName": "平顶山银行", "systemCode": 11 },
        { "systemCodeID": 12, "systemCodeName": "中信银行", "systemCode": 12 },
        { "systemCodeID": 13, "systemCodeName": "郑州银行", "systemCode": 13 },
        { "systemCodeID": 14, "systemCodeName": "光大银行", "systemCode": 14 }
    ],

    // 本人婚姻状况
    maritalstatuslist: [
        {
            value: 1,
            label: '初婚',
        },
        {
            value: 2,
            label: '再婚',
        },
        {
            value: 3,
            label: '离婚',
        },
        {
            value: 4,
            label: '丧偶',
        },
    ],
    // 配偶婚姻状况
    spousemaritalstatuslist: [
        {
            value: 1,
            label: '初婚',
        },
        {
            value: 2,
            label: '再婚',
        },
    ],
    //户口性质
    registeredlist: [
        {
            value: 1,
            label: '农业',
        },
        {
            value: 2,
            label: '非农业',
        },
    ],
    // 是否收养
    adoptionlist: [
        {
            value: 1,
            label: '是',
        },
        {
            value: 0,
            label: '否',
        },
    ],


    //获取当前申报年份
    getCurrentApplyYear() {
        var currentApplyYear = store.getters.currentApplicationYear
        if (currentApplyYear) {
            currentApplyYear = Number(currentApplyYear)
        }
        var myDate = new Date()
        return currentApplyYear || myDate.getFullYear()
    },
    //获取年数据
    getFunYearData() {
        var yearArray = []
        var myDate = new Date()
        var thisYear = myDate.getFullYear() + 1 // 获取当年年份
        var Section = thisYear - 2023 // 声明一个变量 获得当前年份至想获取年份差 eg.2008
        for (var i = 0; i <= Section; i++) {
            let obj = {
                value: thisYear - i,
                label: thisYear - i,
            }
            // yearArray.unshift(obj)
            yearArray.push(obj)
        }
        return yearArray
    },

    //年审审核日期
    getFullYeartime() {
        var now = new Date()
        var FullYeartime =
            now.getFullYear() +
            '-' +
            (now.getMonth() + 1 < 10 ? '0' : '') +
            (now.getMonth() + 1) +
            '-' +
            (now.getDate() < 10 ? '0' : '') +
            now.getDate()

        return new Date(FullYeartime.split(' ')).getTime();
    },

    // 当前年份
    getCurrentYear() {
        var myDate = new Date()
        return myDate.getFullYear()
    },

    //获取年数据
    getMainYearData(isHaveAllYear = false, minYear = 2022, isReverse = false) {
        var yearArray = []
        var myDate = new Date()
        var thisYear = myDate.getFullYear() + 1 // 获取当年年份
        var Section = thisYear - minYear // 声明一个变量 获得当前年份至想获取年份差 eg.2008
        for (var i = 0; i <= Section; i++) {
            let obj = {
                value: thisYear - i,
                label: thisYear - i,
            }
            yearArray.push(obj)
        }
        if (isHaveAllYear) {
            let allobj = {
                value: -1,
                label: '全部',
            }
            yearArray.push(allobj)
        }
        if (isReverse) {
            return yearArray.reverse()
        } else {
            return yearArray
        }
    },




}